import { render, staticRenderFns } from "./LoanRequest.vue?vue&type=template&id=8c94fb80&scoped=true&"
import script from "./LoanRequest.vue?vue&type=script&lang=js&"
export * from "./LoanRequest.vue?vue&type=script&lang=js&"
import style0 from "./LoanRequest.vue?vue&type=style&index=0&id=8c94fb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c94fb80",
  null
  
)

export default component.exports